import { render, staticRenderFns } from "./RewardItem.vue?vue&type=template&id=01f3c8bc&scoped=true&"
import script from "./RewardItem.vue?vue&type=script&lang=js&"
export * from "./RewardItem.vue?vue&type=script&lang=js&"
import style0 from "./RewardItem.vue?vue&type=style&index=0&id=01f3c8bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f3c8bc",
  null
  
)

export default component.exports